module.exports = __webpack_public_path__ + "static/liquidplanner-ac3df99ee7e397b7964f222ea4f1ad3c.png";